
/**
 * localState
 */
export const RENDER_LOCAL_STATE = 'RENDER_LOCAL_STATE';


/**
 * order
 */
export const GET_ALL_ORDERS = 'GET_ALL_ORDERS';
export const GET_ONE_ORDER_BY_TRIP_ID = 'GET_ONE_ORDER_BY_TRIP_ID';



/**
 * poi
 */
export const GET_POI = 'GET_POI';
export const GET_POI_PREFERENCE = 'GET_POI_PREFERENCE';
export const GET_MIXED_POI_BY_CITY = 'GET_MIXED_POI_BY_CITY';
export const GET_POI_FROM_FAVORITE = 'GET_POI_FROM_FAVORITE';
export const GET_POI_NEW = 'GET_POI_NEW';
export const GET_POI_COMMENTS = 'GET_POI_COMMENTS';


/**
 * trip
 */
export const GET_ALL_TRIPS = 'GET_ALL_TRIPS';
export const DELETE_ONE_TRIP = 'DELETE_ONE_TRIP';
export const GET_ONE_DEMO_TRIP = 'GET_ONE_DEMO_TRIP';
export const GET_ONE_TRIP = 'GET_ONE_TRIP';

// 编辑新建行程的参数
export const EDIT_TRIP_PARAMS = 'EDIT_TRIP_PARAMS';
// 追加城市流程需要
export const GET_TRIP_PARAMS_CITIES = 'GET_TRIP_PARAMS_CITIES';
export const EDIT_TRIP_PARAMS_CITIES = 'EDIT_TRIP_PARAMS_CITIES';

// 行程选中的日程
export const SELECT_TRIP_DAY = 'SELECT_TRIP_DAY';
// trip-edit页的行程
export const EDIT_TRIP_EDIT = 'EDIT_TRIP_EDIT';
export const GET_TRIP_EDIT = 'GET_TRIP_EDIT';
// trip-edit-pois页的行程
export const EDIT_TRIP_EDIT_POIS = 'EDIT_TRIP_EDIT_POIS';
export const GET_TRIP_EDIT_POIS = 'GET_TRIP_EDIT_POIS';

// trip-edit-cities页的行程
export const EDIT_TRIP_EDIT_CITIES = 'EDIT_TRIP_EDIT_CITIES';
export const GET_TRIP_EDIT_CITIES = 'GET_TRIP_EDIT_CITIES';

// trip-modify-pois 页的行程
export const EDIT_TRIP_MODIFY_POIS = 'EDIT_TRIP_MODIFY_POIS';
export const GET_TRIP_MODIFY_POIS = 'GET_TRIP_MODIFY_POIS';
// 保存行程
export const SAVE_TRIP = 'SAVE_TRIP';
// 创建行程
export const CREATE_TRIP = 'CREATE_TRIP';


/**
 * trafficRules
 */
export const GET_TRIP_TRAFFIC_RULES = 'GET_TRIP_TRAFFIC_RULES';

/**
 * ticket
 */
export const GET_RECOMMENDED_TICKETS = 'GET_RECOMMENDED_TICKETS';


/**
 * route
 */
// 路线，适用任意场景
// 如果一个页面需要同时请求多条路线，则再为其他路线起名，例如：`GET_FULL_TRIP_ROUTE`
export const GET_ROUTE = 'GET_ROUTE';
// “全程路线”
export const GET_FULL_TRIP_ROUTE = 'GET_FULL_TRIP_ROUTE';


/**
 * region
 */
export const GET_ALL_REGIONS_AND_CLASSIFY = 'GET_ALL_REGIONS_AND_CLASSIFY';
export const SELECT_REGION = 'SELECT_REGION';
export const SELECT_REGION_CLASS = 'SELECT_CLASS';


/**
 * city
 */
export const GET_CITY_LIST_BY_REGION_ID = 'GET_CITY_LIST_BY_REGION_ID';
export const SEARCH_CITY = 'SEARCH_CITY';

/**
 * 收藏夹相关
 */
// 地图poi直接添加到行程
export const POI_SAVE_TRIP = 'POI_SAVE_TRIP';



// WEBPACK FOOTER //
// ./src/store/actionTypes.js